import {
  KeyboardAvoidingView,
  Platform,
  ScrollView,
  StyleSheet,
  Text,
  View,
} from "react-native";
import { useCallback, useEffect, useState } from "react";
import {
  NavigationProp,
  RouteProp,
  useNavigation,
  useRoute,
} from "@react-navigation/native";
import { AuthStackParams } from "../../navigation/Auth/AuthStackParams";
import CustomAlert from "../../components/CoustmizeAlertmsg";
import { Button, Gap } from "../../components";
import { ButtonType } from "../../theme";
import { Auth } from "aws-amplify";
import { LoginRoute } from "../../navigation/Auth/routes";

import * as React from "react";
import { AppTheme, useTheme } from "../../theme/colors";
import TextInput from "../../components/TextInput";
import CurvedBgImage from "../../components/CurvedBgImage";

const ForgotPassword = () => {
  const route = useRoute<RouteProp<AuthStackParams, "ForgotPasswordRoute">>();
  const [username, setUsername] = useState<string>(route.params.email ?? "");
  const [requested, setIsRequested] = useState(false);
  const [code, setCode] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [confirm_password, setConfirmPassword] = useState<string>("");
  const navigation = useNavigation<NavigationProp<AuthStackParams>>();
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [isAlertVisible, setAlertVisibility] = useState(false);
  const [isResetsAlertVisible, setResetAlertVisibility] = useState(false);
  const [isInvalidUserAlertVisible, setInvalidUserAlertVisibility] =
    useState(false);
    const [error, setError] =useState<{title:string,message:string}|null>(null);
    
  const [modalVisible, setModalVisible] = useState(false);
  const theme = useTheme();

  const styles = getStyles(theme);

  useEffect(() => {
    const unsubscribe = navigation.addListener("beforeRemove", () => {
      setIsRequested(false);
    });
    return () => {
      unsubscribe();
    };
  }, [navigation]);

  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (route.params.message) {
      interval = setTimeout(() => {
        setModalVisible(true);
      }, 1000);
    }

    return () => {
      clearTimeout(interval);
    };
  }, [route.params]);

  const onRequestRecovery = useCallback(async () => {
    if (!username) {
      setErrorMessage("Please Enter a email to continue")
      return
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(username)) {
      setErrorMessage("Please enter a valid email address")
      return;
    }
    try {
      await Auth.forgotPassword(username);

      setIsRequested(true);
      setAlertVisibility(true);
    } catch (error: any) {
      if (error?.code === "InvalidParameterException") {
        setInvalidUserAlertVisibility(true);
      }
      else if (error?.code === "LimitExceededException") {
        setErrorMessage(error?.message)
      }
      else if (error?.code === "UserNotFoundException") {
        setErrorMessage(error?.message)
      }
    }
  }, [username]);
  const goBack = () => {
    navigation.goBack(); // This function navigates back to the previous screen
  }; 
  const onPasswordReset = useCallback(async () => {
    try {
      if(password!==confirm_password){
        setError({title:"Password Mismatch",message:"The passwords do not match, Please try again."});
        return;
      }
      const res = await Auth.forgotPasswordSubmit(username, code, password);
      setResetAlertVisibility(true);
    } catch (error:any) {
      setError({title:"Password Reset Failed",message:error.message});
        }
  }, [username, code, password,confirm_password]);

  return (
    <>
      {!requested ? (
        <KeyboardAvoidingView
          style={{ flex: 1, backgroundColor: theme.BACKGROUND }}
          behavior={Platform.select({ ios: "padding", android: "height" })}
        >
          <CurvedBgImage />
          <View style={styles.header}>
            <View
              style={{
                flex: 1,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Text style={styles.heading}>Password Recovery</Text>
            </View>
          </View>
          <ScrollView>
            <View style={{ flex: 1, padding: 20, justifyContent: "center" }}>
              <View>
                <Text style={{ fontSize: 30, fontWeight: "600" }}>
                  Please enter your email to continue.
                </Text>
                <View style={{ marginTop: 50 }}>
                  <TextInput
                    autoCorrect={false}
                    autoCapitalize="none"
                    placeholder="Enter email"
                    label="Email"
                    keyboardType="email-address"
                    value={username}
                    onChangeText={(text) => { setErrorMessage(""); setUsername(text) }}
                  />
                  {errorMessage && (
                    <Text style={styles.errorMessage}>{errorMessage}</Text>
                  )}
                </View>
                <View style={{ alignItems: "center", marginTop: 30 }}>
                  <Button
                    onPress={() => {
                      onRequestRecovery();
                    }}
                    variant={ButtonType.secondary}
                    title="Request Recovery"
                  />
                  <Gap gap={20} />
                  <Button
                    title="Go Back"
                    variant={ButtonType.primary}
                    onPress={goBack}
                  />
                </View>
              </View>
            </View>
          </ScrollView>
        </KeyboardAvoidingView>
      ) : (
        <KeyboardAvoidingView
          style={{ flex: 1, backgroundColor: theme.BACKGROUND }}
          behavior={Platform.select({ ios: "padding", android: "height" })}
        >
          <CurvedBgImage />
          <View style={styles.header}>
            <View
              style={{
                flex: 1,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Text style={styles.heading}>Password Recovery</Text>
            </View>
          </View>
          <ScrollView>
            <View style={{ flex: 1, padding: 20, justifyContent: "center" }}>
              <View style={{ flex: 0.9, gap: 5 }}>
                <Text style={{ fontSize: 30, fontWeight: "600" }}>
                  Please enter the code that was sent to{" "}
                </Text>
                <Text
                  style={{
                    fontSize: 20,
                    fontWeight: "500",
                    color: theme.LIGHT_GREY,
                  }}
                >
                  {username}
                </Text>
                {isAlertVisible && (
                  <Text
                    style={{
                      fontSize: 14,
                      fontWeight: "400",
                      marginVertical: 20,
                    }}
                  >
                    Your request has been taken into an account, if an account
                    is matching we will send you an email
                  </Text>
                )}
                <View style={{ flex: 1, gap: 20, marginTop: 20 }}>
                  <TextInput
                    autoCorrect={false}
                    autoFocus
                    autoCapitalize="none"
                    placeholder="Enter OTP here"
                    label="One Time Passcode"
                    maxLength={6}
                    keyboardType="number-pad"
                    value={code}
                    onChangeText={(text) => setCode(text)}
                  />
                  <TextInput
                    autoCorrect={false}
                    autoCapitalize="none"
                    placeholder="Enter New Password"
                    label="New Password"
                    value={password}
                    secureTextEntry
                    onChangeText={(text) => setPassword(text)}
                  />
                  <TextInput
                    autoCorrect={false}
                    autoCapitalize="none"
                    placeholder="Re-Enter New Password Here"
                    label="Confirm Password"
                    secureTextEntry
                    value={confirm_password}
                    onChangeText={(text) => setConfirmPassword(text)}
                  />
                </View>
                <View style={{ alignItems: "center", marginTop: 60 }}>
                  <Button
                    onPress={onPasswordReset}
                    variant={ButtonType.secondary}
                    title="Reset Password"
                  />
                </View>
              </View>
            </View>
          </ScrollView>
        </KeyboardAvoidingView>
      )}
      <CustomAlert
        cancelText="cancel"
        confirmText="OK"
        visible={isInvalidUserAlertVisible}
        showCancelButton={false}
        title="Non verified user"
        message="Cannot reset password as there is no verified account exists for the email provided."
        onCancel={() => {
          setInvalidUserAlertVisibility(false);
        }}
        onConfirm={() => {
          setInvalidUserAlertVisibility(false);
        }}
      />
      <CustomAlert
        cancelText="cancel"
        confirmText="OK"
        visible={isResetsAlertVisible}
        showCancelButton={false}
        title=""
        message="Pasword Reset Sucessfully"
        onCancel={() => {
          setResetAlertVisibility(false);
        }}
        onConfirm={() => {
          navigation.navigate(LoginRoute);
          setResetAlertVisibility(false);
        }}
      />
      <CustomAlert
        cancelText="cancel"
        confirmText="OK"
        visible={!!route.params.message}
        showCancelButton={false}
        title=""
        message="The provided email already exists in our records, please reset your password if necessary"
        onCancel={() => {
          navigation.setParams({ message: false });
        }}
        onConfirm={() => {
          navigation.setParams({ message: false });  
        }}
      />
          <CustomAlert
        cancelText="cancel"
        confirmText="OK"
        visible={!!error}
        showCancelButton={false}
        title={error?.title||""}
        message={error?.message||""}
        onCancel={() => {
          setError(null);
        }}
        onConfirm={() => {
          setError(null);
        }}
      />
    </>
  );
};

export default ForgotPassword;

const getStyles = (theme: AppTheme) =>
  StyleSheet.create({
    header: {
      height: 95,
      borderBottomStartRadius: 50,
      borderBottomEndRadius: 50,
    },
    heading: {
      fontSize: 16,
      fontWeight: "600",
      color: theme.TEXT,
    },
    errorMessage: {
      marginTop: 10,
      color: theme.ERROR,
      textAlign: "center"
    }
  });
